import React, { useMemo } from 'react';
import ModalTemplate from '../../../../common/modal/modalTemplate';

const breakdownItems = [
    {
        title: 'Booking fee',
        description: 'Paid to Instafix for arranging and managing the booking.',
    },
    {
        title: 'Call-out fee',
        description: 'Paid to Instafix for arranging tradesperson attendance.',
    },
    {
        title: 'Hourly rate',
        description: 'Paid to the tradesperson carrying out the work.',
    },
    {
        title: 'Minimum charge',
        description: 'The first hour is charged as a minimum once work starts.',
    },
    {
        title: 'Additional time',
        description: 'After the first hour, time is charged in 15-minute increments.',
    },
    {
        title: 'Materials and extra costs',
        description: 'Materials are only charged if approved by the customer. Parking and congestion may be added at cost where applicable.',
    },
];

const PriceBreakdown = ({ show, handleClose }) => {
    const content = useMemo(
        () => (
            <div className="card border-0 shadow-none mb-0">
                <div className="card-body px-3 px-md-4 py-3">
                    <h4 className="text-center text-dark fw-semibold mt-3 mb-4">
                        Price breakdown
                    </h4>

                    {breakdownItems.map(({ title, description }, index) => (
                        <div
                            key={title}
                            className="mb-4"
                        >
                            <h5 className="text-dark text-lg mb-1">
                                {index + 1}. {title}
                            </h5>

                            <p className="text-md mb-0 ms-3">
                                {description}
                            </p>
                        </div>
                    ))}

                    <p className="text-muted mt-3 mb-0">
                        Labour, materials and approved extras are charged by
                        the tradesperson. Instafix collects these payments
                        through the platform as payment agent.
                    </p>
                </div>

                <div className="text-center pb-4">
                    <button
                        className="btn btn-link text-secondary mb-0"
                        type="button"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        ),
        [handleClose]
    );

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            size={null}
            centered
            isRemoveBodyPadding
            body={content}
        />
    );
};

export default React.memo(PriceBreakdown);